import { type FirebaseApp, initializeApp } from 'firebase/app';
import {
  type Auth,
  browserLocalPersistence,
  connectAuthEmulator,
  getAuth,
  setPersistence,
} from 'firebase/auth';

import { selectedSettings } from 'common/config/firebase-config';

let app: FirebaseApp;
let auth: Auth;

export function initializeFirebaseApp() {
  app = initializeApp(selectedSettings.firebaseConfig);
  auth = getAuth(app);
  setPersistence(auth, browserLocalPersistence);

  if (__USE_LOCAL_AUTH__) {
    connectAuthEmulator(auth, `http://localhost:${__EMULATOR_AUTH_PORT__}`);
  }
}

export function getFirebaseAuth(): Auth {
  return auth;
}

export function getFirebaseApp(): FirebaseApp {
  return app;
}
